import { render, staticRenderFns } from "./ModuleLicense.vue?vue&type=template&id=9c66d320&scoped=true&lang=pug&"
import script from "./ModuleLicense.vue?vue&type=script&lang=js&"
export * from "./ModuleLicense.vue?vue&type=script&lang=js&"
import style0 from "./ModuleLicense.vue?vue&type=style&index=0&id=9c66d320&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c66d320",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
